import React from 'react';
import classNames from 'classnames';

import styles from './fadeInOnLoad.module.css';

export interface InputProps {
  className?: string;
  onError?: React.ReactEventHandler<HTMLImageElement>;
}

interface State {
  isLoaded: boolean;
}

export function fadeInOnLoad<T>(
  WrappedComponent: React.ComponentType<T & InputProps>
): React.ComponentType<T & InputProps> {
  return class extends React.PureComponent<T & InputProps, State> {
    constructor(props: T & InputProps) {
      super(props);
      this.state = {
        isLoaded: false,
      };
    }

    setLoaded = () => this.setState({ isLoaded: true });

    // A <source> swap reuses this img, so a failed replacement must not keep the previous image's loaded state
    handleError: React.ReactEventHandler<HTMLImageElement> = e => {
      this.setState({ isLoaded: false });
      this.props.onError?.(e);
    };

    render() {
      const { className } = this.props;
      const { isLoaded } = this.state;
      const rootClassName = classNames(className, styles.imageFade, {
        [styles.imageFadeLoaded]: isLoaded,
      });
      return (
        <WrappedComponent
          {...this.props}
          className={rootClassName}
          data-loaded={isLoaded || undefined}
          onLoad={() => this.setLoaded()}
          onError={this.handleError}
        />
      );
    }
  };
}
